module.exports = __webpack_public_path__ + "media/customizations/regencyattentrails/logo-new-22532fe3152ccec389c242158d88ab74.png";